import {
  CognitoIdentityCredentialProvider,
  fromCognitoIdentity,
} from '@aws-sdk/credential-providers';
import cookies from 'browser-cookies';

import apiFetch from '@scale/frontend-lib/api-fetch';
import { IS_PROD, IS_FEDERAL } from '@scale/frontend-lib/constants';

// tokens provided expire after 6 hours, expire sooner to avoid using expired token
const COGNITO_TOKEN_EXPIRATION_DAYS = 4 / 24;

let creds: CognitoIdentityCredentialProvider | null = null;

/** Retrieves cognito ID & token from either local storage or internalapi. This can throw an error. */
async function getCognitoLogin(): Promise<{ identityId: string; token: string }> {
  if (IS_FEDERAL) {
    throw new Error('Not allowed in federal');
  }
  const storedLogin = cookies.get('cognito');
  if (storedLogin) {
    try {
      return JSON.parse(storedLogin);
    } catch (e) {
      // Ignore this error & retrive new creds from internalapi
    }
  }
  const resp = await apiFetch(null, `internal/cognito/auth`);
  cookies.set('cognito', JSON.stringify(resp), {
    expires: COGNITO_TOKEN_EXPIRATION_DAYS,
    secure: IS_PROD, // don't use on localhost
  });
  return resp;
}

export async function getCredentials() {
  if (IS_FEDERAL) {
    throw new Error('Not allowed in federal');
  }
  if (!creds || creds) {
    const { identityId, token } = await getCognitoLogin();
    let initialToken: string | null = token;
    creds = fromCognitoIdentity({
      identityId,
      logins: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'cognito-identity.amazonaws.com': async () => {
          if (initialToken) {
            const token = initialToken;
            initialToken = null;
            return token;
          }
          return (await getCognitoLogin()).token;
        },
      },
      clientConfig: { region: 'us-west-2' },
    });
  }
  return creds;
}
